import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { empty, of } from 'rxjs'
import { catchError, filter, startWith, switchMap, map } from 'rxjs/operators'
import { fetchMember, fetchMemberInit } from 'api/planet/member'
import { isOneOfOldRoutes } from 'helpers/PathHelper'
import { queryFromString } from 'helpers/url'
import { setExtraContext, setTagsContext, setUserContext } from 'helpers/raven'
import * as Actions from 'store/actions/index.ts'
import { handleClosedSale } from './helpers/handleClosedSale'
import { handleUnauthorized } from './helpers/handleUnauthorized'
import {
  getLoggedIn,
  getMemberLoggingIn,
  getOperationCodeFromUri,
  getURIPartner,
  getURILocale
} from '../selectors'

const authenticationNotStarted = state =>
  !getMemberLoggingIn(state) && !getLoggedIn(state)

const AuthenticationEpic = (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  filter(() => authenticationNotStarted(state$.value)),
  map(action => action.payload.location),
  switchMap(({ search, pathname }) => {
    const { cypherSSO, device, evtKey, marketId } = queryFromString(search)
    const opeCode = getOperationCodeFromUri(state$.value)
    const isOldRouting = isOneOfOldRoutes(pathname)
    const locale = getURILocale(state$.value)
    const partner = getURIPartner(state$.value)

    if (!cypherSSO && !opeCode) { return empty() }

    if (cypherSSO) { window.__INIT__ = cypherSSO }

    const fetch = cypherSSO
      ? fetchMemberInit(cypherSSO, device)
      : fetchMember(isOldRouting ? evtKey : opeCode, marketId, partner, locale, device)

    return fetch.pipe(
      switchMap(({ response }) => {
        setUserContext({
          id: response.member.memberId
        })
        setTagsContext({
          apiEnv: response.env,
          deviceType: response.device,
          operationCode: response.operationCode,
          operationId: response.operationId,
          saleVersion: response.version
        })
        setExtraContext({
          authenticationType: cypherSSO ? 'init' : 'member',
          cypherSSO
        })
        return of(Actions.member.onMemberInfoFetched(response))
      }),
      startWith(Actions.member.onAuthenticating()),
      catchError(error => {
        const redirectionHandler = error.status === 404
          ? handleClosedSale
          : handleUnauthorized

        return redirectionHandler(actions$, state$).pipe(
          startWith(Actions.member.onAuthenticationError(error))
        )
      })
    )
  })
)

export default AuthenticationEpic
